export default __webpack_public_path__ + "static/media/bike_image7.073dda32.jfif";